import { Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/auth.slice";
import GroupListScreen from "../GroupListScreen";
import useGroupBranchOptions from "../useGroupBranchOptions";
import { fetchGroupAdmins } from "../../../services/groupConsole.service";

// User has no first_name/last_name of its own — for an admin that data lives
// only on the linked Admin document, at r.admin.
const nameColumn = {
  title: "Name",
  key: "name",
  render: (r) =>
    [r.admin?.first_name, r.admin?.last_name].filter(Boolean).join(" ") ||
    r.username ||
    "—",
};

const GroupAdmins = () => {
  const user = useSelector(selectUser);
  const branches = useGroupBranchOptions();
  return (
    <GroupListScreen
      title="Admins"
      queryKey="group-console-admins"
      fetchFn={fetchGroupAdmins}
      searchPlaceholder="Search by name, username or email"
      branchOptions={branches.options}
      branchOptionsLoading={branches.isLoading}
      columns={[
        nameColumn,
        { title: "Email", dataIndex: "email", align: "center" },
        {
          title: "Role",
          key: "role",
          align: "center",
          render: (r) =>
            String(r.group ?? "") === String(user?.group) ? (
              <Tag color="blue">Group admin</Tag>
            ) : (
              <Tag>Branch admin</Tag>
            ),
        },
      ]}
    />
  );
};

export default GroupAdmins;
